import React, { FunctionComponent } from 'react'
import classnames from 'classnames'
import { CheckMark } from '../../icons/checkMark'

export interface Props {
  icon: string
  status: string
  text: string
  // Optional trailing content, e.g. a link to the place the problem is fixed.
  children?: React.ReactNode
}

export const StatusBanner: FunctionComponent<Props> = ({
  icon,
  status,
  text,
  children,
}) => {
  const backgroundColor = (status) => {
    switch (status) {
      case 'SOLD':
        return 'status-banner--green'
      case 'DISABLED':
      case 'ADDRESS_NEEDED':
        return 'status-banner--yellow'
      case 'FRAUD':
        return 'status-banner--pink'
      default:
        return null
    }
  }

  return (
    <div className={classnames('status-banner', backgroundColor(status))}>
      {icon === 'other' ? (
        <CheckMark color="#FFF" height="16px" width="16px" />
      ) : (
        <img className="status-banner__image" src={icon} alt="" />
      )}

      <p className="status-banner__text">
        {text}
        {children}
      </p>
    </div>
  )
}

StatusBanner.displayName = 'StatusBanner'

export default StatusBanner
